<template>
  <v-container>
    <v-layout row wrap>
      <v-flex pa-1>
        <v-card class="text-xs-center pt-2 pb-0">
          <h3>Verbruik</h3>
          <v-spacer></v-spacer>
          <ChartContainer />
          <!--
          TODO
          Todo aan/uitvinken elektriciteit en gas
          Dropdown voor periode selectie (laatste 10min, laatste uur, vandaag, deze week, deze maand, dit jaar, aangepast met twee datapickers)
          -->
          
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>

      <v-flex v-if="meta && meta.error" xs12 sm12 md4 lg4 xl4>
        <v-card>
          <div>{{meta.error}}</div>
        </v-card>
      </v-flex>
      
      <Widget v-if="current_energy_use" title="Huidig verbruik" large_screen_width="4" :items="[{'type': 'electricity', 'data': current_energy_use.electricity, 'attribute': 'current_wattage', 'unit': 'Watt'}]"/>
      
      <Widget v-if="statistics" title="Verbruik vandaag" large_screen_width="4"
      :items="[{'type': 'electricity', 'data': statistics.electricity, 'attribute': 'received_today', 'unit': 'kWh'},
      {'type': 'gas', 'data': statistics.gas, 'attribute': 'received_today', 'unit': 'm3'}]"/>
      
      <Widget v-if="statistics" title="Verbruik gisteren" large_screen_width="4"
      :items="[{'type': 'electricity', 'data': statistics.electricity, 'attribute': 'received_yesterday', 'unit': 'kWh', },
      {'type': 'gas', 'data': statistics.gas, 'attribute': 'received_yesterday', 'unit': 'm3'}]"/>

      <Widget v-if="statistics && statistics.meta.returns_electricity" title="Nettoverbruik" large_screen_width="4"
      :items="[{'type': 'electricity', 'data': statistics.electricity, 'attribute': 'net_received_today', 'unit': 'kWh vandaag'},
      {'type': 'electricity', 'data': statistics.electricity, 'attribute': 'net_received_yesterday', 'unit': 'kWh gisteren'}]"/>

      <Widget v-if="statistics" title="Piekverbruik" large_screen_width="4"
      :items="[{'type': 'electricity', 'data': statistics.electricity, 'attribute': 'received_peak_today', 'unit': 'Watt vandaag'},
      {'type': 'electricity', 'data': statistics.electricity, 'attribute': 'received_peak_this_year', 'unit': 'Watt dit jaar'}]"/>

      <Widget v-if="statistics && statistics.meta.returns_electricity" title="Teruglevering" large_screen_width="4"
      :items="[{'type': 'electricity', 'data': statistics.electricity, 'attribute': 'returned_today', 'unit': 'kWh vandaag'},
      {'type': 'electricity', 'data': statistics.electricity, 'attribute': 'returned_this_year', 'unit': 'kWh dit jaar'}]"/>

      <Widget v-if="statistics && statistics.meta.returns_electricity" title="Piek teruglevering" large_screen_width="4"
      :items="[{'type': 'electricity', 'data': statistics.electricity, 'attribute': 'returned_peak_today', 'unit': 'Watt vandaag'},
      {'type': 'electricity', 'data': statistics.electricity, 'attribute': 'returned_peak_this_year', 'unit': 'Watt dit jaar'}]"/>

    </v-layout>
  </v-container>
</template>

<script>
import ChartContainer from '../components/ChartContainer.vue'
import Widget from '../components/Widget.vue'
import axios from 'axios'

export default {
  name: 'dashboard',
  components: {
    ChartContainer,
    Widget,
  },
  data: function() {
    return {
      polling_current_usage: null,
      polling_statistics: null,
      last_update: null,
      statistics: null,
      current_energy_use: null,
      meta: null,
    }
  },
  created: function() {
    if (!localStorage.signedIn) {
      this.$router.replace('/')
    } else {
      this.updateCurrentUse()
      this.polling_current_usage = setInterval(this.updateCurrentUse, 1000)
      this.updateStatistics()
      this.polling_statistics = setInterval(this.updateStatistics, 10000)
    }
  },
  beforeDestroy: function() {
    clearInterval(this.polling_current_usage)
    clearInterval(this.polling_statistics)
  },
  methods: {
    updateCurrentUse: function() {
      this.$http.secured.get('/current_energy_use')
        .then(response => {
          this.current_energy_use = response.data.current_energy_use
          this.meta = response.data.meta
          })
    },
    updateStatistics: function() {
      this.$http.secured.get('/statistics')
        .then(response => {
          this.statistics = response.data.statistics
          this.meta = response.data.meta
          })
    }
  }
}
</script>

<style scoped>
</style>
